<!--
Author: TangChen
Date: 2018-11-17
Desc: 设置适当性弹窗组件，为公共组件
 -->
<template>
    <div class="comp-risk-dialog comp">
        <el-dialog
            v-if="fund.fundcode"
            title="阅读风险警示"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div v-if="fund.way==='P4'" class="fund-risk-info">
                    <p><span>基金名称：</span><span>{{ fund.fundname }}</span></p>
                    <p><span>产品风险等级：</span><span>{{ $cache.getDict('110143',fund.risklevel) }}风险</span></p>
                    <p><span>您的风险评测结果：</span><span>{{ $cache.getDict('100017',info.custrisk) }}</span></p>
                </div>
                <div v-if="fund.way==='P4' && fund.risklevel > info.custrisk" class="prompt-info">
                    <p class="red">
                        您所购买产品的风险等级已超过您的风险承受能力，可能会造成本金损失，请确认已阅知该风险警示。
                    </p>
                </div>
                <div v-if="fund.way!=='P4'" class="prompt-info">
                    <p><i class="el-icon-warning" /><span>是否确认{{ (fund.way==='P8'?'暂停':'终止')+fund.fundname+'('+(fund.fundcode === "515981" ? "515980" : fund.fundcode)+')' }}基金</span></p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="80px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                        <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="btnAgree">
                    我已阅知风险
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "RiskDialog",
    props: {
        fund: {
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    data () {
        return {
            dialogVisible: false,
            btnMsg: "我已阅知风险",
            info: "",
            isPwdCheck: false,
            ruleForm: {
                pwd: ""
            },
            fundAll: {},
            rules: {
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        fund (val) {
            if (val.fundcode) {
                this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
                this.fundAll = val;
                this.getRiskCheck();
            }
        }
    },
    mounted () {
        this.info = this.$cache.getUser();
    },
    methods: {
        btnAgree () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.fundAll.tpasswd = this.$util.enc(this.ruleForm.pwd);
                    this.dialogVisible = false;
                    if (this.fundAll.way === "P4") {
                        this.fundAll.opertype = "0";
                    }
                    this.$emit("event-fn", this.fundAll);
                } else {
                    return false;
                }
            });
        },
        getRiskCheck () {
            const _this = this;
            this.$util.fundRiskCheck(this, { fundcode: this.fund.fundcode, proto: "buy" }, res => {
                if (res) {
                    _this.$util.getSdxProtocol(res,data=>{
                        if(data){
                            _this.fundAll = Object.assign({}, this.fundAll, data);
                            _this.ruleForm.pwd = "";
                            _this.dialogVisible = true;
                        }
                    });
                    
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-risk-dialog {
    .prompt-info {
        .el-icon-warning {
            color: $color-a;
            margin-right: 8px;
            font-size: $f24;
            vertical-align: middle;
        }
        span {
            vertical-align: middle;
        }
    }
    .two-cols-form {
        margin-top: 10px;
    }
    .fund-risk-info {
        padding: 10px 0 15px;
        border-bottom: 1px solid $border-color3;
        p {
            &:after {
                content: "";
                clear: both;
                overflow: hidden;
                display: block;
                height: 0;
            }
            line-height: 24px;
            span:first-of-type {
                display: inline-block;
                width: 140px;
                text-align: right;
            }
            span:last-of-type {
                color: $text-color2;
                width: 300px;
                display: inline-block;
                float: right;
            }
        }
    }
}
</style>
